import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    number: '01',
    title: 'Free Strategy Call',
    description: "A 15-minute call to understand your brand, goals, and challenges. No pitch — just a conversation to see if we're the right fit."
  }, {
    number: '02',
    title: 'Custom Proposal',
    description: 'Within 48 hours, you get a tailored proposal: scope, timeline, pricing, and specific recommendations for your store and growth strategy.'
  }, {
    number: '03',
    title: 'Build & Launch',
    description: "Our team executes. Regular updates, transparent communication, and a dedicated point of contact. Whether it's a new build, migration, or SEO campaign — we deliver on time."
  }, {
    number: '04',
    title: 'Grow & Optimize',
    description: "We don't disappear after launch. Ongoing optimization, performance monitoring, and continuous improvement to grow your revenue month over month."
  }];
  return <section className="py-24 bg-gray-50 border-y border-gray-100" data-id="element-170">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-171">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-172">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold font-heading text-navy mb-4" data-id="element-173">
            How It Works
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-gray-600" data-id="element-174">
            From first call to growth — here's what to expect.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative" data-id="element-175">
          {/* Connecting Line (Desktop) */}
          <div className="hidden lg:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-gray-200 -z-10" data-id="element-176"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="relative" data-id="element-177">
              <div className="w-24 h-24 mx-auto bg-white rounded-full border-4 border-gray-50 flex items-center justify-center shadow-sm mb-6 relative z-10" data-id="element-178">
                <span className="text-3xl font-bold font-heading text-teal" data-id="element-179">
                  {step.number}
                </span>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 h-[calc(100%-6rem)] flex flex-col items-center text-center hover:shadow-md transition-shadow" data-id="element-180">
                <h3 className="text-xl font-bold font-heading text-navy mb-4" data-id="element-181">
                  {step.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-182">
                  {step.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}